import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import { FaInstagram } from "react-icons/fa6";

const callNumber = "0653244067";
const whatsappLink = "https://wa.me/255653244067";
const instagramLink = "https://www.instagram.com/novatechnologiestz/";
const email = "info@novatechnologies.com";
const locationValue = "Tanzania, Dar es Salaam, Makumbusho Derm Plaza, 11th Floor";
const mapsLink = "https://maps.google.com/?q=-6.777002,39.245758";

export const contactItems = [
  {
    icon: <MdPhone size={24} />,
    title: "Call",
    value: callNumber,
    href: `tel:${callNumber}`,
    type: "link",
  },
  {
    icon: <FaWhatsapp size={22} />,
    title: "WhatsApp",
    value: callNumber,
    href: whatsappLink,
    type: "external",
  },
  {
    icon: <FaInstagram size={22} />,
    title: "Instagram",
    value: "@novatechnologiestz",
    href: instagramLink,
    type: "external",
  },
  {
    icon: <MdEmail size={24} />,
    title: "Email",
    value: email,
    href: `mailto:${email}`,
    type: "link",
  },
  {
    icon: <MdLocationOn size={24} />,
    title: "Address",
    value: locationValue,
    href: mapsLink,
    type: "external",
  },
];

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 300);
    return () => clearTimeout(timer);
  }, []);

  if (!ready) {
    return (
      <div className="container py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section 
      className="contact-hero-section position-relative overflow-hidden"
      style={{
        background: `url('/assets/banner1.jpg') center/cover no-repeat`,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Overlay for readability */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.92) 0%, rgba(30, 41, 59, 0.88) 50%, rgba(51, 65, 85, 0.85) 100%)",
          zIndex: 1,
        }}
      />

      {/* Decorative elements */}
      <div className="position-absolute top-0 end-0 w-50 h-100 opacity-10" 
           style={{ 
             background: "radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.3) 0%, transparent 50%)",
             zIndex: 1 
           }} 
      />
      <div className="position-absolute bottom-0 start-0 w-40 h-60 opacity-10" 
           style={{ 
             background: "radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.3) 0%, transparent 50%)",
             zIndex: 1 
           }} 
      />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        {/* Header */}
        <div className="text-center mb-5 pb-3" data-aos="fade-up">
          <h1 className="display-5 fw-bold text-white mb-3">
            Contact <span className="text-primary">Nova Technologies</span>
          </h1>
          <p className="section-copy text-light opacity-90 col-lg-7 mx-auto" style={{ fontSize: "1.1rem" }}>
            Use the contact details below to call, message, or email us directly. 
            We're here to help bring your technology vision to life.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="row g-4 justify-content-center">
          {contactItems.map((item, idx) => (
            <div
              key={item.title}
              className="col-md-6 col-xl-3"
              data-aos="fade-up"
              data-aos-delay={100 + idx * 80}
            >
              <div 
                className="contact-card h-100 p-4 rounded-4 position-relative overflow-hidden"
                style={{
                  background: "rgba(30, 41, 59, 0.7)",
                  border: "1px solid rgba(148, 163, 184, 0.2)",
                  backdropFilter: "blur(12px)",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  cursor: item.href ? "pointer" : "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.6)";
                  e.currentTarget.style.boxShadow = "0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(59, 130, 246, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.borderColor = "rgba(148, 163, 184, 0.2)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                onClick={() => {
                  if (item.href && item.type === "external") {
                    window.open(item.href, "_blank", "noopener,noreferrer");
                  }
                }}
              >
                {/* Animated gradient border effect */}
                <div 
                  className="position-absolute top-0 start-0 w-100 h-1"
                  style={{
                    background: "linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.8), transparent)",
                    transform: "scaleX(0)",
                    transition: "transform 0.4s ease",
                  }}
                />
                
                {/* Icon Badge */}
                <div 
                  className="icon-badge mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: "64px",
                    height: "64px",
                    background: "linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2))",
                    border: "2px solid rgba(59, 130, 246, 0.4)",
                    color: "#60a5fa",
                    transition: "all 0.3s ease",
                  }}
                >
                  {item.icon}
                </div>

                {/* Content */}
                <h5 className="text-white fw-semibold mb-3 text-center">{item.title}</h5>
                
                {item.href ? (
                  <a
                    href={item.type === "external" ? undefined : item.href}
                    target={item.type === "external" ? "_blank" : undefined}
                    rel={item.type === "external" ? "noopener noreferrer" : undefined}
                    className="contact-link d-block text-center text-decoration-none"
                    style={{ 
                      color: "rgba(203, 213, 225, 0.95)", 
                      fontSize: "0.95rem",
                      lineHeight: "1.5",
                      transition: "color 0.2s ease",
                      wordBreak: "break-word"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = "#60a5fa"}
                    onMouseLeave={(e) => e.currentTarget.style.color = "rgba(203, 213, 225, 0.95)"}
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="m-0 text-center" style={{ 
                    color: "rgba(203, 213, 225, 0.95)", 
                    fontSize: "0.95rem",
                    lineHeight: "1.5"
                  }}>
                    {item.value}
                  </p>
                )}

                {/* Hover accent */}
                <div 
                  className="position-absolute bottom-0 start-50 translate-middle-x w-0 h-0.5 bg-primary"
                  style={{ 
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div className="text-center mt-5 pt-4" data-aos="fade-up" data-aos-delay="500">
          <p className="text-light opacity-75 mb-0 small">
            Prefer a quick chat? <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="text-info text-decoration-none fw-medium">Message us on WhatsApp</a>
          </p>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .contact-hero-section {
          padding: 4rem 0;
        }
        .contact-card:hover .icon-badge {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.35), rgba(139, 92, 246, 0.35));
          border-color: rgba(59, 130, 246, 0.8);
          color: #93c5fd;
          transform: scale(1.05);
        }
        .contact-card:hover > div:first-of-type {
          transform: scaleX(1);
        }
        .contact-card:hover .position-absolute.bottom-0 {
          width: 60%;
        }
        @media (max-width: 768px) {
          .contact-hero-section {
            min-height: auto;
            padding: 3rem 0;
          }
        }
      `}</style>
    </section>
  );
}